import * as React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { filterClearIcon } from '@progress/kendo-svg-icons';

export const ContainsTextFilterCell: React.FC<GridFilterCellProps> = (props) => {
    const { value, onChange, title } = props;

    const hasValue = (v: any) => v !== '' && v !== undefined && v !== null;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange({
            value: e.target.value,
            operator: e.target.value ? 'contains' : '',
            syntheticEvent: e as any
        });
    };

    const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        onChange({
            value: '',
            operator: '',
            syntheticEvent: e as any
        });
    };

    return (
        <td className="k-table-td">
            <div className="k-filtercell" title={title}>
                <div className="k-filtercell-wrapper">
                    <span className="k-textbox k-input k-input-md k-input-solid k-rounded-md">
                        <input
                            className="k-input-inner"
                            value={value || ''}
                            onChange={handleChange}
                        />
                    </span>
                    <Button
                        title="Clear"
                        onClick={handleClear}
                        disabled={!hasValue(value)}
                        svgIcon={filterClearIcon}
                    />
                </div>
            </div>
        </td>
    );
};